import { AccessDenied } from '@/components/ui/access-denied';
import { useAccessControl } from '@/hooks/useAccessControl';
import TermsPage from '@/modules/faq-tc/terms';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/dashboard/faq-tc/terms')({
  component: RouteComponent,
});

function RouteComponent() {
  const { canAccessFaqManagement } = useAccessControl();

  return canAccessFaqManagement ? <TermsPage /> : <AccessDenied />;
}
